<template>
  <a-card :bordered="false">
    <div class="salesCard">
      <a-tabs default-active-key="1" @change="changeTabs" size="large" :tab-bar-style="{marginBottom: '5px', paddingLeft: '16px'}">
        <a-tab-pane loading="true" tab="员工" key="1">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQueryCus1">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="12">
                    <a-form-item label="工号">
                      <a-input placeholder="请输入工号" v-model="queryParam.employeeNo" allowClear></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="12">
                    <a-form-item label="姓名">
                      <a-input placeholder="请输入姓名" v-model="queryParam.name" allowClear></a-input>
                    </a-form-item>
                  </a-col>

                  <a-col :xl="6"  :sm="12">
                    <a-form-item label="事业群">
                        <a-select
                            placeholder="请选择事业群"
                            v-model="queryParam.businessGroupId"
                            :options="businessGroupOptions"
                            @change="handleGroupVal"
                            allowClear>
                        </a-select>
                    </a-form-item>
                </a-col>

                <!-- <a-col :xl="6" :sm="12">
                    <a-form-item label="事业处">
                        <a-select
                            placeholder="请选择事业处"
                            v-model="queryParam.businessUnitId"
                            :options="businessUnitOptions"
                            allowClear>
                        </a-select>
                    </a-form-item>
                </a-col> -->


                  <a-col :md="6" :sm="12">
                    <a-form-item label="手机">
                      <a-input placeholder="请输入手机" v-model="queryParam.mobile" allowClear></a-input>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="12">
                    <a-form-item label="核酸采样日期">
                      <j-date placeholder="" class="query-group-cust" v-model="queryParam.startTime" ></j-date>
                      <span class="query-group-split-cust"></span>
                      <j-date placeholder="" class="query-group-cust" v-model="queryParam.endTime" ></j-date>

                    </a-form-item>
                  </a-col>




                  <a-col :md="6" :sm="12">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQueryCus1(1)" icon="search">查询</a-button>
                        <a-button type="primary" @click="searchResetCus1" icon="reload" style="margin-left: 8px">重置</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>

            <!-- 操作按钮区域 -->
            <div class="table-operator" style="border-top: 5px">
                <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
                    <a-menu slot="overlay">
                      <a-menu-item key="1" @click="batchDel1"><a-icon type="delete"/>删除</a-menu-item>
                    </a-menu>
                <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
              </a-dropdown> -->
            </div>

            <!-- table区域-begin -->
            <div>
              <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
                <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
                <a style="margin-left: 24px" @click="onClearSelected">清空</a>
              </div>

              <a-table
                ref="table"
                bordered
                size="middle"
                rowKey="id"
                :scroll="{x:2000}"
                :columns="columns1"
                :dataSource="dataSource1"
                :pagination="ipagination"
                :loading="loading"
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                @change="handleTableChange1">

                <template slot="avatarslot" slot-scope="text, record">
                  <div class="anty-img-wrap">
                    <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
                  </div>
                </template>

                <span slot="action1" slot-scope="text, record">
                  <a v-has="'emp2:edit'" @click="handleEditEmp(record)" >编辑</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete1(record.id)">
                    <a v-has="'emp2:delete'">删除</a>
                  </a-popconfirm>
                  <a-divider type="vertical" />
                  <a v-has="'emp2:detail'" @click="handleDetailEmp(record)">查看</a>
                </span>
            </a-table>
          </div>
            <!-- table区域-end -->
        </a-tab-pane>

        
      </a-tabs>
    </div>


    <employee-modal ref="modalFormEmp" @ok="modalFormOk1"></employee-modal>
  </a-card>
</template>

<script>
    import { ReportListMixin } from '@/mixins/ReportListMixin'
    import {postAction,getAction,httpAction,deleteAction,getFileAccessHttpUrl} from '@/api/manage';
    import JInput from '@/components/jeecg/JInput'
    import EmployeeModal from './modules/EmployeeModal.vue';
    

    export default {
    name: "EmpList",
    mixins: [ReportListMixin],
    components: {
      JInput,
      EmployeeModal,
    },
    data() {
      return {
        model:{},
        dataSource1:[],
        dataSource2:[],
        columns:[],
        appCode:"prevent",
        url: {
          delete: "/prevent/epm/delete",
          deleteBatch: "/prevent/epm/deleteBatch",
          exportXlsUrl: "/sys/sysUserApplyAudit/exportXls",
          queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"
        },
        businessGroupOptions:[],
        businessUnitOptions:[],

        //图片插槽
        previewVisible: false,

      }
    },
    computed: {
        language() {
            return this.$store.getters.language
        },
        columns1(){
              if(this.language){
                return  [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:function (t,r,index) {
                        return parseInt(index)+1;
                        }
                    },
                   
                    {
                        title: '工号',
                        align:"center",
                        dataIndex: 'employeeNo'
                    },
                    {
                        title:'姓名',
                        align:"center",
                        dataIndex: 'name'
                    },
                    {
                        title:'法人',
                        align:"center",
                        dataIndex: 'legalPerson'
                    },
                    {
                        title:'事业群',
                        align:"center",
                        dataIndex: 'bgName'
                    },
                    {
                        title:'事业处',
                        align:"center",
                        dataIndex: 'buName'
                    },
                    {
                        title:'在职状态',
                        align:"center",
                        dataIndex: 'isWork_dictText'
                    },
                    {
                        title:'手机',
                        align:"center",
                        dataIndex: 'mobile'
                    },
                    {
                      title:'核酸采样时间',
                      align:"center",
                      dataIndex: 'collectTime'
                    },
            //         {
            //             title:'核酸时态',
            //             align:"center",
            //             dataIndex: 'hourDiff',
            //             customRender:function (text,r,index) {
            //                 if(text) {
            //                   let hour=text.split(':')[0]
            //                   let minute=text.split(':')[1]
            //                   if(hour<24){
            //                      return '24H内'
            //                   }
            //                   if(hour>=24 && hour<48){
            //                       return '24~48H内'
            //                   }
            //                   if(hour>=48 && hour<72){
            //                       return '48~72H内'
            //                   }
            //                   if(hour>=72){
            //                     return '超72H'
            //                   }
            //                 }
            //                return '无记录'
            //             }
            //         },
                   
                    {
                        title:'核酸采样更新时间',
                        align:"center",
                        dataIndex: 'checkTime'
                    },
                    {
                        title: this.language['common.action'],
                        dataIndex: 'action',
                        align:"center",
                        fixed:"right",
                        width:147,
                        scopedSlots: { customRender: 'action1' }
                    }
                ]
             }
            },
        
    },
    created() {
        this.initBusinessGroupList();
        this.searchQueryCus1();


    },
     methods: {
       /********************************初始化数据*******************************************************/
         initBusinessGroupList(){
            getAction(this.url.queryBusinessGroupList,{applicationCode: this.appCode}).then(res=>{
            if(res.success){
                this.businessGroupOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.departName, value: item.id}
                return c;
                })
            }
            })
      },
        handleGroupVal(val){
            getAction(this.url.queryBusinessUnitList,{id:val}).then(res=>{
                if(res.success){
                    this.businessUnitOptions = res.result.map((item,index,arr)=>{
                    let c = {label:item.departName, value: item.id}
                    return c;
                    })
                }
            })
        },
        /********************************查询*******************************************************/
         changeTabs(key){
            if(key == "1"){
              this.searchQueryCus1();
            }
         },

        searchQueryCus1(arg){//员工
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
              this.ipagination.current = 1;
            }

            this.loading = true;
            let params = this.getQueryParams();
            console.log('params: ', params);
             postAction('/prevent/epm/getEmpList2',params).then((res) => {
                if (res.success) {
                    const result = res.result.records || res.result
                    this.dataSource1 = result.map((v, i)=>{
                        v.key = i + 1;
                        v.updateTime = v.updateTime || new Date().toLocaleString('lt-LT');
                        v.factoryName = v.factoryName || '未绑定';
                        v.province = v.province || '未绑定';
                        v.city = v.city || '未绑定';
                        v.buildingName = v.buildingName || '未绑定';
                        v.areaName = v.areaName || '未绑定';
                        v.detectionTime = v.detectionTime || '无记录';
                        v.healthCode_dictText = v.healthCode_dictText || '无记录';
                        v.result_dictText = v.result_dictText || '无记录';
                        return v;
                    });
                    if(res.result.total){
                        this.ipagination.total = res.result.total;
                    }else{
                        this.ipagination.total = 0;
                    }

                }else{
                    this.$message.warning(res.message);
                }
            }).finally(() => {
                this.loading = false
            })


        },

        

        searchResetCus1(){//重置1
          this.queryParam = {}
          this.searchQueryCus1(1);
        },
        

        modalFormOk1() { //新增 和  修改 点击确定 执行此方法
            // 新增/修改 成功时，重载列表
            this.searchQueryCus1(1);
            //清空列表选中
            this.onClearSelected()
        },

        

        handleDelete1: function (id) {
          if(!this.url.delete){
            this.$message.error("请设置url.delete属性!")
            return
          }
          var that = this;
          deleteAction('/prevent/epm/delete', {id: id}).then((res) => {
            if (res.success) {
              //重新计算分页问题
              that.reCalculatePage(1)
              that.$message.success(res.message);
              that.searchQueryCus1(1);
              this.onClearSelected()
            } else {
              that.$message.warning(res.message);
            }
          });
        },

        batchDel1: function () {
            if(!this.url.deleteBatch){
              this.$message.error("请设置url.deleteBatch属性!")
              return
            }
            if (this.selectedRowKeys.length <= 0) {
              this.$message.warning('请选择一条记录！');
              return;
            } else {
              var ids = "";
              for (var a = 0; a < this.selectedRowKeys.length; a++) {
                ids += this.selectedRowKeys[a] + ",";
              }
              var that = this;
              this.$confirm({
                title: "确认删除",
                content: "是否删除选中数据?",
                onOk: function () {
                  that.loading = true;
                  deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                    if (res.success) {
                      //重新计算分页问题
                      that.reCalculatePage(that.selectedRowKeys.length)
                      that.$message.success(res.message);
                      // that.loadData();
                      that.searchQueryCus1(1);
                      that.onClearSelected();
                    } else {
                      that.$message.warning(res.message);
                    }
                  }).finally(() => {
                    that.loading = false;
                  });
                }
              });
            }
          },

        

          handleTableChange1(pagination, filters, sorter) {//监听 排序/分页
            //分页、排序、筛选变化时触发
            console.log(pagination)
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.searchQueryCus1();
         },

/********************************图片*******************************************************/
        /* imgView(text){//预览 弹框
          this.previewImage = text;
          this.previewVisible = true;

          this.uploadFlag =false;
        }, */

        viewImage(record){//查看健康码
            this.model.id = record.id
            let path = getFileAccessHttpUrl(record.healthImage,this.appCode)
            this.model.healthImage =path

            this.previewVisible = true;
        },

        handleCancel() {//关闭 弹框
          this.previewVisible = false;
        },

        getImgViewCode(text,code){//得到 预览图片url
          if(text && text.indexOf(",")>0){
            text = text.substring(0,text.indexOf(","))
          }
          return getFileAccessHttpUrl(text,code)
        },

        uploadImag(record){//上传弹框
          this.model={}
          this.model.id = record.id
          this.previewVisible =true
        },

        handleOk(){//上传 确定
           //更新 health_image
           httpAction('/prevent/visitor/editImageUrl',this.model,'put').then(res=>{
              if (res.success) {
                this.previewVisible =false;
                this.$message.success(res.message);
                this.searchQueryCus2();

                // this.$emit('ok');

              }else{
                this.$message.warning(res.message);
              }
           })
        },

     }

    }

</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>